'use client';

import { createContext, useContext, type PropsWithChildren, type ReactElement } from 'react';
import useDictionaryAccessors, { type TDictionaryData } from './useDictionaryAccessors';

type DictionariesContextType = ReturnType<typeof useDictionaryAccessors>;

export const DictionariesContext = createContext<DictionariesContextType | null>(null);

export const useDictionariesContext = (): DictionariesContextType => {
  const context = useContext(DictionariesContext);

  if (!context) {
    throw new Error('useDictionariesContext must be used within DictionariesProvider');
  }

  return context;
};

interface IProps extends PropsWithChildren {
  dictionaries: TDictionaryData,
}

export const DictionariesProvider = ({ children, dictionaries }: IProps): ReactElement => (
  <DictionariesContext.Provider value={ useDictionaryAccessors(dictionaries) }>
    { children }
  </DictionariesContext.Provider>
);
